__webpack_require__.p = "https://store-assets.worldofsolomon.com/";